import { render, staticRenderFns } from "./snappayCard.vue?vue&type=template&id=36d2d8e2&scoped=true&"
import script from "./snappayCard.vue?vue&type=script&lang=js&"
export * from "./snappayCard.vue?vue&type=script&lang=js&"
import style0 from "./snappayCard.vue?vue&type=style&index=0&id=36d2d8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2d8e2",
  null
  
)

export default component.exports